export const FETCH_USERS_SUCCESS = "FETCH_USERS_SUCCESS";
export const SET_USERS_FIELD = "SET_COMPANIES_FIELD";
export const SET_USER_DELETE_DIALOG_LOADING = "SET_USER_DELETE_DIALOG_LOADING";
